/**
 * Native <dialog> js
 * ======================================
 * - target dialog via [href] or [data-modal] attribute
 */

const ELEMENTS = ".js-dialog";
const CLOSE_BTNS = ".js-dialog-close";

class Dialog {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS);
    this.close_btns = document.querySelectorAll(CLOSE_BTNS);

    if (!this.elements) {
      return false;
    }

    this.elements.forEach((el) => {
      el.addEventListener("click", this.bindOpen, false);
    });

    this.close_btns.forEach((el) => {
      el.addEventListener("click", this.bindClose, false);
    });
  }

  bindOpen = (e) => {
    const el =
      e.currentTarget.getAttribute("href") || e.currentTarget.getAttribute("data-modal");
    const modal = document.querySelector(el);

    e.preventDefault();

    this.showModal(modal);
  };

  bindClose = (e) => {
    const modal = e.currentTarget.closest("dialog");

    modal.classList.add('is-hiding')

    modal.addEventListener('webkitAnimationEnd', function animationEndHandler(){
      modal.classList.remove('is-hiding');
      modal.close();
      modal.removeEventListener('webkitAnimationEnd', animationEndHandler);
    }, false);
  };

  showModal = (modal) => {
    if (modal) {
      modal.showModal();
    }
  };

  closeModal = (modal) => {
    modal.close();
  };
}

new Dialog();
